<template>
  <div class="pwc-info-item">
    <div class="pwc-info-wrapper">
      <!-- <v-icon class="pwc-item-icon">{{ info.icon }}</v-icon> -->
      <span class="pwc-item-title">{{ info.name }}</span>
    </div>
    <span class="pwc-item-value">{{ info.value }}</span>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {
        return {
          name: 'name',
          value: 'value',
          icon: 'fas fa-ellipsis-v'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pwc-info-item {
    margin-top: 12px;
    margin-bottom: 12px;
    display: flex;
    .pwc-info-wrapper {
        min-width: 100px;
    }
    .pwc-item-icon {
        line-height: 20px;
        margin-right: 12px;
        color:#D04A02;
        font-size: 12px;
    }
    .pwc-item-title {
        line-height: 24px;
        font-size: 16px;
        margin-right: 12px;
        font-weight: bold;
    }
    .pwc-item-value {
        line-height: 24px;
        font-size: 14px;
    }
}
</style>
